import { PettyCashStateTypes, PettyCashActionTypes } from "./PettyCash.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PettyCashStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PettyCashReducer = (
  state: PettyCashStateTypes = INITIAL_STATE,
  action: any
): PettyCashStateTypes => {
  switch (action.type) {
    case PettyCashActionTypes.FETCH_ALL_PETTY_CASH:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashActionTypes.FETCH_ALL_PETTY_CASH_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashActionTypes.FETCH_ALL_PETTY_CASH_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashActionTypes.FETCH_ALL_PETTY_CASH_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PettyCashActionTypes.FETCH_ONE_PETTY_CASH:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashActionTypes.FETCH_ONE_PETTY_CASH_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashActionTypes.FETCH_ONE_PETTY_CASH_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashActionTypes.FETCH_ONE_PETTY_CASH_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PettyCashReducer;
